module.exports = __webpack_public_path__ + "img/custom-score.14787110.gif";